/*  eslint-disable */

import { useState, useEffect, useRef } from "react";
import { Container } from "reactstrap";
import {  Utils, API, Http, Images } from "Helpers";
import { PlayerCard } from 'Modals';
import { GameweekNativeSlider, PitchView, MobHeader } from "Components";
import FixtureMT from 'Components/FixturesComp/FixtureMT';
import { useLocation, useHistory  } from 'react-router-dom';


export default function TeamOfTheWeek(props) {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const dt_week = searchParams.get('dt_week');
    const history = useHistory();
	const [activeView, setActiveView] = useState("pitch");
	const [SelectedWeek, setSelectedWeek] = useState(dt_week);
	const [isPlayerCardShow, setIsPlayerCardShow] = useState(false);
	const [ALL_POSITION_CLONE, setALL_POSITION_CLONE] = useState("");
	const [Weeks, setWeeks] = useState([]);
	const [SelectedPlayer, setSelectedPlayer] = useState('')
    const [LineupList, setLineupList] = useState([]);
	const [lineup_master_id, setLineup_master_id] = useState('');
	const [teamWiseWeek, setTeamWiseWeek] = useState([]);
	const [playerWeek, setPlayerWeek] = useState([]);
	const [gameweeklastupdate, setGameweeklastupdate] = useState(
		new Date().valueOf()
	);
	const data = JSON.parse(localStorage.getItem("current_lineup"));
	const contestData = JSON.parse(localStorage.getItem("contestData"));

	 const [activeTooltip, setActiveTooltip] = useState(null);
 	 const containerRef = useRef(null);

  const handleClick = (index) => {
    setActiveTooltip(activeTooltip === index ? null : index);
  };
   useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setActiveTooltip(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

	const GetTeamOfWeekData = () => {
		let param = {
			sports_id: contestData.sports_id,
			league_id: contestData.league_id,
			week: SelectedWeek,
			add_plyr_data: "1",
		};
		Http.post(API.GET_TEAM_OF_WEEK, param).then((responseJson) => {
			try {
				setTeamWiseWeek(responseJson.data);
				const playerUid = responseJson.data?.pow?.player_uid;
				const playerDetails = responseJson.data?.tow?.[playerUid];

				// Add total_score from pow to playerDetails
				const totalScore = responseJson.data?.pow?.total_score;

				const fullPlayerDetails = {
					...playerDetails, // Spread the player details
					total_score: totalScore, // Add the total_score
				};

                setPlayerWeek(fullPlayerDetails)
                const createLineup = Object.values(responseJson.data.tow);

                // Update each player object with the jersey URL
                const updatedLineup = createLineup.map(player => {
                    // Add the jersey URL to each player object
                    return {
                        ...player,  // Spread existing player data
                        jersey: Utils.playerJersyUrl(player.jersey)  // Add the jersey URL
                    };
                });

                
                setLineupList(updatedLineup)
			} catch (error) {
				console.log(error);
			}
		});
	};
	const slider = useRef(null); // Assuming slider is a reference to a slick slider

	const generateWeeksArray = (start, end) => {
		const weeks = [];
		for (let i = Number(start); i <= Number(end); i++) {
			weeks.push({ week: i });
		}
		return weeks;
	};
	useEffect(() => {
		if (data) {
			const weeksArray = generateWeeksArray(data.start_week, dt_week);

			setWeeks(weeksArray);
			//setSelectedWeek(data.start_week);
			setGameweeklastupdate(new Date().valueOf());

			Utils.setNext(data.week_info.next_week);

			if (slider.current && SelectedWeek !== null) {
				slider.current.slickGoTo(Number(SelectedWeek) - 1);
			}
			//GetTeamOfWeekData();
            getLineupMasterData();
		}
	}, []);

    const getLineupMasterData = () => {
        const { league_id, sports_id } = contestData;

        Http.post(API.GET_LINEUP_MASTER_DATA, {
        league_id, sports_id
        }).then(response => {
        const { data } = response;
        setALL_POSITION_CLONE(data.all_position)
        setLineup_master_id(data.lineup_master_id)
        }).catch(error => {
        console.error(error)
        });
    }

	const SelectWeekHandle = (item) => {
        setSelectedWeek(item.week);
		setGameweeklastupdate(new Date().valueOf());
	};

    useEffect(()=>{
        GetTeamOfWeekData()
    },[SelectedWeek])

	let MobHeaderProps = {
		titleContest: contestData,
		backTitleAction: "",
		drawerMenu: true,
		backHandle: true,
	};

	const goBack = () => {
        history.goBack();
    };


    const PlayerCardInit = (SelectedPlayer) => {		
        setSelectedPlayer(SelectedPlayer)
        PlayerCardToggle()
    }

    const  PlayerCardToggle = () => {
        setIsPlayerCardShow(!isPlayerCardShow)
    }
  


    const PitchViewProps = {
          team_info:null,
          is_leagueD: true,
          LineupList,
          ALL_POSITION: {},
          ALL_POSITION_CLONE,
    
          joined_week:contestData.joined_week,
          active_week:contestData.active_week,
          next_week:contestData.next_week,
          last_week:contestData.last_week,
    
          SelectedLeague:Utils.getMultiLeg(),
          lineup_master_id: lineup_master_id,
    
          RosterMasterData:{},
          LineupLoader:false,
          IS_POINT: true,
          SelectedWeek,
          CurrentLineup:{},
          getLineupRosterLimit: null,
          PlayerCardInit: PlayerCardInit,
          hideBtn: true,
          message:'',
		  isTeamoFtheWeek: true
        }

        const PlayerCardProps = {
            isOpen: isPlayerCardShow,
            toggle: PlayerCardToggle,
            selected_league: Utils.getMultiLeg(),
            Player: SelectedPlayer,
            SelectedWeekCard:SelectedWeek
        }

		const checkDate = (inputDate) => {
			const now = new Date() && new Date();
			const enteredDate = new Date(inputDate);
			const differenceInHours = Math.abs(enteredDate - now) / (1000 * 60 * 60);
			const isSameDay = now.toDateString() === enteredDate.toDateString();
			const isWithin24Hours = differenceInHours <= 24;
			if (isSameDay) {
				return "Today";
			} else if (enteredDate > now) {
				if (isWithin24Hours) {
					return "Tomorrow";
				} else {
					return "Future Date";
				}
			} else {
				if (isWithin24Hours) {
					return "Yesterday";
				} else {
					return "Past Date";
				}
			}
		};

		const headers = [
			{ short: "Pts", full: "Points" },
			{ short: "MP", full: "Matches Played" },
			{ short: "GS", full: "Goals Scored" },
			{ short: "A", full: "Assists" },
			{ short: "CS", full: "Clean Sheets" },
			{ short: "GC", full: "Goals Conceded" },
			{ short: "OG", full: "Own Goals" },
			{ short: "PS", full: "Penalties Saved" },
			{ short: "PM", full: "Penalties Missed" },
			{ short: "YC", full: "Yellow Cards" },
			{ short: "RC", full: "Red Cards" },
			{ short: "S", full: "Saves" },
			{ short: "SAL", full: "Salary" },
		];

	return (
		<Container className="xpt28-p cont-spc-mob remove-padding">
			<MobHeader {...MobHeaderProps} />
			<div className="title-for-dashboard my-team">
				<div className='contest-info-myteam team-of-week gray'>
                  <div className='contest-info-head'>
                    <span className='curved-btn' onClick={() => goBack()}>
                        <span><i className="icon-previous"/></span>
                    </span>
                    <h6>Team of the week</h6>
                  </div>
                    {/* <div className='contest-info-subhead'>
                      <h5>{contestData.league_name}</h5>
                      <span className='gameweek-lbl'>{Utils.getWeekLabel(Utils.getMultiLeg().week_abbr[contestData.start_week])} {contestData.start_week} - {contestData.end_week}</span>
                      <span className='seprate'>|</span>
                      <div className="schedule-date">
                          {checkDate(contestData.deadline_date) === "Today" && !Utils.hasDateTimePassed(Utils.getUtcToLocal(contestData.deadline_date))? (
                              <div className="count-clock">
                                  <CountDownCustom
                                      targetDate={Utils.getUtcToLocal(contestData.deadline_date)}
                                  />
                              </div>
                          ) :
                          contestData.status == "3" ? <div className='completed'>Completed</div> :
                          (checkDate(contestData.deadline_date) === "Yesterday" || checkDate(contestData.deadline_date) === "Past Date") || Utils.hasDateTimePassed(Utils.getUtcToLocal(contestData.deadline_date))? 
                                <div className='contest-live'>Live <img src={Images.LIVE_RED_ARROW} alt="next-live"/></div>
                            :
                            (
                              <div className="schedule-date">
                                  <Moment
                                      date={Utils.getUtcToLocal(contestData.deadline_date)}
                                      format="DD MMM - hh:mm A"
                                  />
                              </div>
                          )}
                      </div>
                    </div> */}
                </div>
			</div>

			<div className="head-team-top">
				{SelectedWeek && (
					<div className="native-slider-wrap">
						<GameweekNativeSlider
							{...{
								scoring_weeks: Weeks,
								SelectedWeek,
								gameweeklastupdate,
								SelectWeekHandle: SelectWeekHandle,
								is_fixture: true,
							}}
						/>
					</div>
				)}
				<div className="dashboard-container">
					<div className="top-section">
						<div className="player-of-week-card">
							<div className="potw-left">
								<div className="potw-title">Player of the Week</div>
								<div className="potw-player">
									<div className="jersey-icon">
										<img
                                            src={Utils.playerJersyUrl(playerWeek.jersey)}
                                            width={80}
                                            alt=""
                                        />
									</div>
									<div className="potw-details">
										<div className="potw-name" onClick={()=>PlayerCardInit(playerWeek)}>{playerWeek.full_name}</div>
										<div className="potw-team-pos">{playerWeek.team_abbreviation} | {playerWeek.position}</div>
										<div className="potw-points">{playerWeek.fantasy_score} <span className="regular">Pts</span></div>
									</div>
                                    <div className="potw-points mob">{playerWeek.fantasy_score} <span>Points</span></div>

								</div>
							</div>
							<div className="potw-right">
								<div className="total-points-section">
									<div className="total-points-label">Total Points</div>
									<div className="total-points-value">{playerWeek.total_score}</div>
									{/* <div className="overall-link">Overall →</div> */}
								</div>
							</div>
						</div>
					</div>
                    <div className="view-toggle-wrap">
                        <div className={`view-toggle`}>
                            <button
                                onClick={() => setActiveView("pitch")}
                                className={`view-toggle-button ${activeView === "pitch" ? "active" : ""}`}
                            >
                                PITCH VIEW
                            </button>
                            <button
                                onClick={() => setActiveView("list")}
                                className={`view-toggle-button ${activeView === "list" ? "active" : ""}`}
                            >
                                LIST VIEW
                            </button>
                        </div>
                    </div>
					<div className="main-content">
						{activeView === "pitch" ? (
							<div className="pitch-view-of-week">
                                <PitchView  {...PitchViewProps}  />
                                
							</div>
						) : (

							<div className="players-table">
								<div className="table-header"  ref={containerRef}>
									<div className="header-player">Player</div>
									{headers.map((h, i) => (
										<div
											key={i}
											className="header-stat"
											style={{ position: "relative", cursor: "pointer" }}
											onClick={() => handleClick(i)}
										>
										{h.short}
										{activeTooltip === i && (
											<div
											className="cus-tooltip"
											>
											{h.full}
											</div>
										)}
										</div>
									))}
								</div>
								{Object.values(teamWiseWeek.tow).map((player, index) => (
									<div key={index} className="player-row-full">
										<div className="player-info">
											<div className="player-jersey">
												<img
													src={Utils.playerJersyUrl(player.jersey)}
													width={30}
													alt=""
												/>
											</div>
											<div className="player-details">
												<div className="player-name-tbl-week" onClick={()=>PlayerCardInit(player)}>{player.full_name}</div>
												<div className="player-team-pos">
													{player.team_abbreviation} | {player.position}
												</div>
											</div>
										</div>
										<div className="stat-cell">{player.fantasy_score}</div>
										<div className="stat-cell">{player.minutes}</div>
										<div className="stat-cell">{player.goals}</div>
										<div className="stat-cell">{player.assists}</div>
										<div className="stat-cell">{player.clean_sheets}</div>
										<div className="stat-cell">{player.goals_conceded}</div>
										<div className="stat-cell">{player.own_goals}</div>
										<div className="stat-cell">{player.penalty_saves}</div>
										<div className="stat-cell">{player.penalty_misses}</div>
										<div className="stat-cell">{player.yellow_cards}</div>
										<div className="stat-cell">{player.red_cards}</div>
										<div className="stat-cell">{player.saves}</div>
										<div className="stat-cell">{player.salary}</div>
									</div>
								))}
							</div>
						)}
					</div>
				</div>
                {SelectedWeek && <div className='white-fixture-wrap-team'>
                { <FixtureMT
                  no_ad
                  selected_league={Utils.getMultiLeg()}
                  lastupdate={gameweeklastupdate}
                  league_week={SelectedWeek}
                />}
              </div>}
			</div>

			{
                isPlayerCardShow &&
                <PlayerCard {...PlayerCardProps} />
            }
		</Container>
	);
}
